import { render, staticRenderFns } from "./endereco.vue?vue&type=template&id=58353202"
import script from "./endereco.vue?vue&type=script&lang=js"
export * from "./endereco.vue?vue&type=script&lang=js"
import style0 from "./endereco.vue?vue&type=style&index=0&id=58353202&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports